import { render, staticRenderFns } from "./IconAI.vue?vue&type=template&id=600773f8&scoped=true"
import script from "./IconAI.vue?vue&type=script&lang=js"
export * from "./IconAI.vue?vue&type=script&lang=js"
import style0 from "./IconAI.vue?vue&type=style&index=0&id=600773f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600773f8",
  null
  
)

export default component.exports